import React, { Component } from "react";
import classnames from "classnames";
import ReactDOM from "react-dom";
import { isFunction, microAppUtil } from "@platform/api";
import HotKeys from "../HotKeys";
import { getSysFieldid } from "@platform/api";
import PageContainer from '../PageContainer';
import WidgetSide from './widgetSide';

require("./index.less");

export default class Sidebox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.defaultPopContainer = microAppUtil.getPopContainer();
        this.defaultBody = microAppUtil.getDocument();
        // this.html = null;
    }

    //sidebox-显示时需要动态计算top,若含有affix取affix的top

    componentDidMount() {
        // this.html = document.getElementsByTagName("html");
        let { show } = this.props;
        if (show) {
            !this.hasOwnProperty('prevOverFlow') && (this.prevOverFlow = window.getComputedStyle(this.defaultPopContainer).overflow);
            this.defaultPopContainer.style.overflow = 'hidden';
        } else {
            if (this.hasOwnProperty('prevOverFlow')) {
                this.defaultPopContainer.style.overflow = this.prevOverFlow;
                delete this.prevOverFlow;
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            !this.hasOwnProperty('prevOverFlow') && (this.prevOverFlow = window.getComputedStyle(this.defaultPopContainer).overflow);
            this.defaultPopContainer.style.overflow = 'hidden';
        } else if (prevProps.show && !this.props.show) {
            if (this.hasOwnProperty('prevOverFlow')) {
                this.defaultPopContainer.style.overflow = this.prevOverFlow;
                delete this.prevOverFlow;
            }
        }
    }

    componentWillUnmount() {
        if (this.hasOwnProperty('prevOverFlow')) {
            this.defaultPopContainer.style.overflow = this.prevOverFlow;
            delete this.prevOverFlow;
        }
    }

    render() {
        let {
            mask,
            show,
            style,
            maskClose,
            className,
            title,
            onClose,
            closeButton,
            showButton,
            buttonClick,
            width,
            propContainer,
            buttonDisabled = [],
            getHeaderBtns,
            zIndex,
            pageClassType,
        } = this.props;
        let classname = "sidebox " + (className || "");
        // if (this.html && this.html[0]) {
        //     if (show && mask) {
        //         this.html[0].style.overflow = "hidden";
        //     } else {
        //         this.html[0].style.overflow = "";
        //     }
        // }
        let zIndexObj = zIndex ? { zIndex: zIndex } : {};
        if (!Number.isNaN(Number(width))) {
            width = Number(width) + "px";
        }

        let popContainer = typeof propContainer === 'function' ? propContainer() : propContainer;
        if(!popContainer){
            popContainer = microAppUtil.getDocument();
        }

        return popContainer ? ReactDOM.createPortal(
            show && (
                <section style={style} className={classname}>
                    {mask && (
                        <div
                            className="sidebox-mask"
                            style={zIndexObj}
                            onClick={() => {
                                isFunction(maskClose) && maskClose();
                            }}
                        />
                    )}
                    <HotKeys
                        // keyMap={{ colse: "f4" }}
                        // handlers={{
                        //     colse: () => {
                        //         isFunction(onClose) && onClose();
                        //         // this.setState({ show: false });
                        //     },
                        // }}
                        keyMap={{
                            cancelBtnHandler:
                                HotKeys.USUAL_KEYS.ICON_CLOSE,
                        }}
                        handlers={{
                            cancelBtnHandler: () => {
                                console.log('sideBox 关闭');
                                isFunction(onClose) && onClose();
                            },
                        }}
                        className="close-hotkeys-wrapper"
                        focused={true}
                        display="inline"
                    />
                    <div
                        className="sidebox-content disabled-bg-btn"
                        style={propContainer ? { width, position: 'absolute', ...zIndexObj } : { width, ...zIndexObj }}
                        fieldid={getSysFieldid("sidebox_modal-area")}
                    >
                        <div
                            className="sidebox-header"
                            fieldid={getSysFieldid("header-area")}
                        >
                            <span
                                className="sidebox-title"
                                fieldid={getSysFieldid(`${title}_title`)}
                            >
                                {title}
                            </span>
                            <span className="goto-opre">
                                <span className="custom-button-area">{typeof getHeaderBtns === 'function' && getHeaderBtns()}</span>
                                {showButton && (
                                    <span className="icon-wrapper">
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-shangyiye first",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[0],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("first");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-jiantouzuo prev",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[1],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("prev");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-jiantouyou next",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[2],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("next");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-xiayiye end",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[3],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("end");
                                            }}
                                        />
                                    </span>
                                )}

                                {
                                    closeButton
                                        ?
                                        closeButton
                                        :
                                        <span
                                            className="icon iconfont icon-you icon-celashouqi"
                                            onClick={onClose}
                                        />
                                }
                            </span>
                        </div>
                        {
                            pageClassType ? (
                                <PageContainer pageClassType={pageClassType}>
                                    < div className="sidebox-body" > {
                                        this.props.children
                                    } </div>
                                </PageContainer>)
                                : (<div className="sidebox-body"> {
                                    this.props.children
                                } </div>)
                        }

                    </div>
                </section>
            ),
            popContainer,
        ) : null;
    }
}

Sidebox.WidgetSide = WidgetSide;